import { render, staticRenderFns } from "./ListPagesCapituloView.vue?vue&type=template&id=4747143c&scoped=true"
import script from "./ListPagesCapituloView.vue?vue&type=script&lang=js"
export * from "./ListPagesCapituloView.vue?vue&type=script&lang=js"
import style0 from "./ListPagesCapituloView.vue?vue&type=style&index=0&id=4747143c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4747143c",
  null
  
)

export default component.exports